import { DialogContent } from "@/components/ui/dialog"
import { cn } from "@/lib/utils"
import { ReactNode } from "react"

interface ModalFrameProps {
  type: string
  title: string
  description: string
  accent?: "primary" | "accent"
  highlight?: string
  children: ReactNode
}

export function ModalFrame({ type, title, description, accent = "primary", highlight, children }: ModalFrameProps) {
  return (
    <DialogContent
      className={cn(
        "max-h-[min(95vh,900px)] max-w-3xl border-none bg-transparent p-0 shadow-none sm:max-w-5xl",
      )}
    >
      <div className="relative flex max-h-[min(95vh,900px)] flex-col overflow-hidden rounded-3xl border border-border/60 bg-background shadow-2xl">
        <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-primary/10" aria-hidden="true" />
        <div className="relative z-10 flex flex-1 flex-col gap-6 p-6 md:p-10">
          <div className="flex flex-col gap-3">
            <div
              className={cn(
                "inline-flex w-fit items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em]",
                accent === "primary"
                  ? "border-primary/40 bg-primary/10 text-primary"
                  : "border-accent/40 bg-accent/10 text-accent",
              )}
            >
              {type}
            </div>
            <div className="space-y-3">
              <h2 className="font-heading text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
                {title}
              </h2>
              <p className="max-w-3xl text-base leading-relaxed text-muted-foreground md:text-lg">
                {description}
              </p>
              {highlight ? (
                <p className={cn(
                  "text-sm font-semibold uppercase tracking-wide",
                  accent === "primary" ? "text-primary" : "text-accent",
                )}>
                  {highlight}
                </p>
              ) : null}
            </div>
          </div>
          <div className="flex flex-1 flex-col overflow-y-auto pr-2">
            {children}
          </div>
        </div>
      </div>
    </DialogContent>
  )
}

